import { isLocale } from '~/types/locale';

// Note teach_plus is the code for plus_annual for some reason we store the subscription this way
export const UserSubscriptionCodesForUS = [
  'free',
  'plus_monthly',
  'teach_plus',
  'plus_lite',
] as const;
export const UserSubscriptionCodesForRestOfWorld = [
  'free',
  'essential_annual',
  'teach_plus',
  'school_plan',
  'school_ultimate',
  'school_plan_member',
  'school_plan_admin_only',
] as const;
export type UserSubscriptionCode =
  | (typeof UserSubscriptionCodesForRestOfWorld)[number]
  | (typeof UserSubscriptionCodesForUS)[number]
  | 'administrator';

export const isUserSubscriptionCodeForLocation = (
  code: string,
  location: string
): code is UserSubscriptionCode => {
  if (!isLocale(location)) {
    return false;
  }
  const planCodes =
    location === 'us' ? UserSubscriptionCodesForUS : UserSubscriptionCodesForRestOfWorld;
  return new Set<string>(planCodes).has(code);
};

export const RecurlyPlanCodes = [
  'free', // This code is not in recurly
  'plus_annual',
  'plus_monthly',
  'essential_annual',
  'school_plan',
  'plus_lite',
] as const;
export const PlanFeatureConditions = [
  'free_limited',
  'free_view',
  'essential_limited',
  'essential_view',
] as const;
export type RecurlyPlanCode = (typeof RecurlyPlanCodes)[number];
export type PlanFeatureConditions = (typeof PlanFeatureConditions)[number];

export const isRecurlyPlanCode = (code: string): code is RecurlyPlanCode => {
  return RecurlyPlanCodes.includes(code as RecurlyPlanCode);
};
export const isRecurlyPlanCodeForLocation = (
  code: string,
  location: string
): code is RecurlyPlanCode => {
  return (
    (isLocale(location) && isRecurlyPlanCode(code) && location === 'us') || code !== 'plus_monthly'
  );
};

export const asRecurlyPlanCode = (code: UserSubscriptionCode): RecurlyPlanCode | undefined => {
  switch (code) {
    case 'teach_plus':
      return 'plus_annual';
    case 'administrator':
      return undefined;
    default:
      return isRecurlyPlanCode(code) ? code : undefined;
  }
};

export interface Plan {
  title: string;
  subheading?: string;
  subheadingPrice?: string;
  footer?: string;
  slug: RecurlyPlanCode;
  code: UserSubscriptionCode;
  usageAllowance: number;
  price: {
    value: number;
    undiscountedPrice?: number;
    discountPercentage?: number;
    displayAsMonthly?: boolean;
    code: string;
    symbol: string;
  };
  recommended: boolean;
  period?: string;
  hideFromDetailsTable?: boolean;
  experiment?: boolean;
}
